<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> {{ pageTitle }} </BreadcrumbItem>
    </Breadcrumb>
    <a-alert
        v-if="sectionThree.internalState==='已驳回' || sectionThree.internalRiskState==='已驳回'"
        :message="mode==='risk-approve'?'风险评估驳回意见':'驳回意见'"
        :description="sectionThree.auditOpinion"
        type="warning"
        show-icon
        style="margin: 10px 10px 0 20px;"
    />
    <div class="page-title-container">
      <span class="page-title">前期手续 - {{ sectionThree.projectName }}</span>
    </div>
    <div class="content-container">
      <div class="container">
        <div class="steps-content">

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">备案证</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="registration.docList"
                    @preview="onPreviewFile"
                    @change="onRegistrationDocUpload"
                >
                  <a-button> <a-icon type="upload" /> 备案证 </a-button>
                </a-upload>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">电网消纳意见</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="gridIngestion.docList"
                    @preview="onPreviewFile"
                    @change="onGridIngestionUpload"
                >
                  <a-button> <a-icon type="upload" /> 电网消纳意见 </a-button>
                </a-upload>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">荷载报告</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="loadReport.docList"
                    @preview="onPreviewFile"
                    @change="onLoadReportUpload"
                >
                  <a-button> <a-icon type="upload" /> 荷载报告 </a-button>
                </a-upload>
              </div>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">初设方案</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="initialDesign.docList"
                    @preview="onPreviewFile"
                    @change="onInitialDesignUpload"
                >
                  <a-button> <a-icon type="upload" /> 初设方案 </a-button>
                </a-upload>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">环保部门意见（环评登记表）</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="envReview.docList"
                    @preview="onPreviewFile"
                    @change="onEnvReviewDocChange"
                >
                  <a-button> <a-icon type="upload" /> 环评登记表 </a-button>
                </a-upload>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">电力接入系统方案</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="powerConnection.docList"
                    @preview="onPreviewFile"
                    @change="onPowerConnectionUpload"
                >
                  <a-button> <a-icon type="upload" /> 电力接入方案 </a-button>
                </a-upload>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">电网接入系统方案批复</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="powerConnectionReply.docList"
                    @preview="onPreviewFile"
                    @change="onPowerConnectionReplyUpload"
                >
                  <a-button> <a-icon type="upload" /> 电网接入批复 </a-button>
                </a-upload>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">社稳意见（若涉及需提供）</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="socialStable.docList"
                    @preview="onPreviewFile"
                    @change="onSocialStableUpload"
                >
                  <a-button> <a-icon type="upload" /> 附件上传 </a-button>
                </a-upload>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">技术可行性</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="techFeasible.docList"
                    @preview="onPreviewFile"
                    @change="onTechFeasibleUpload"
                >
                  <a-button> <a-icon type="upload" /> 附件上传 </a-button>
                </a-upload>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">其他资料</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="otherAttachment.docList"
                    @preview="onPreviewFile"
                    @change="onOtherAttachmentUpload"
                >
                  <a-button> <a-icon type="upload" /> 附件上传 </a-button>
                </a-upload>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <DocPreview ref="docPreview" />
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {baseURL} from "@/services/HttpService";
import {loadSectionThree, saveSectionThree} from "@/services/SpecService";
import DocPreview from "@/views/DocPreview.vue";

export default {
  props: {
    projectId: String,
    mode: String
  },
  emits: ['sectionSaved','saveSectionFailed'],
  components: {DocPreview, BreadcrumbItem, Breadcrumb },
  data() {
    return {
      pageTitle: "新增表单",
      current: 2,
      headers: {
        authorization: 'authorization-text',
      },
      uploadUrl: baseURL + "/upload/spec",
      viewUrl: baseURL + "/attachment?fileName=",
      sectionThree: {
        invoiceRatio: "",
        roi:""
      },
      registration:{
        loading: false,
        docList: [],
        title: ""
      },
      landUsageOpinion: {
        loading: false,
        docList: [],
        title: "用地意见"
      },
      envReview: {
        loading: false,
        docList: [],
        title: "环评登记表"
      },
      socialStable: {
        loading: false,
        docList: [],
        title: "社稳意见"
      },
      loadReport: {
        loading: false,
        docList: [],
        title: ""
      },
      initialDesign: {
        loading: false,
        docList: [],
        title: ""
      },
      gridIngestion: {
        loading: false,
        docList: [],
        title: ""
      },
      powerConnection: {
        loading: false,
        docList: [],
        title: ""
      },
      powerConnectionReply: {
        loading: false,
        docList: [],
        title: ""
      },
      techFeasible: {
        loading: false,
        docList: [],
        title: "技术可行性"
      },
      otherAttachment: {
        loading: false,
        docList: [],
        title: "其他资料"
      },
    };
  },
  created() {
    this.projectId = this.$route.params.id;
    this.mode = this.$route.params.mode;
    if(this.projectId!=='0') {
      this.pageTitle = "编辑表单";
    }
  },
  mounted() {
    this.startLoadSectionThree();
  },
  methods: {
    getCompanyId(){
      return this.sectionThree.companyId;
    },
    startLoadSectionThree(){
      if(this.projectId!=="0") {
        loadSectionThree(this.projectId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            let data = resp.data.data;
            this.sectionThree = data;

            this.buildDocList(data.loadReportDocList, 'loadReport');
            this.buildDocList(data.initialDesignDocList, 'initialDesign');
            this.buildDocList(data.gridIngestionDocList, 'gridIngestion');
            this.buildDocList(data.powerConnectionDocList, 'powerConnection');
            this.buildDocList(data.powerConnectionReplyDocList, 'powerConnectionReply');
          }
        });
      }
    },
    buildDocList(docList, propName) {
      if(docList && docList.length > 0) {
        for (let i = 0; i < docList.length; i++) {
          let doc = docList[i];
          this[propName].docList.push({
            uid: doc.uid,
            name: doc.name,
            status: 'done',
            url: this.viewUrl + doc.url
          });
        }
      }
    },
    changeToAbsImgPath(info){
      let fileList = [...info.fileList];

      fileList = fileList.map(file => {
        if (file.response) {
          file.url = this.viewUrl + file.response.data;
        }
        console.log("fileUrl", file.url);
        return file;
      });
      return fileList;
    },
    prepareDocList(docList, params, propName){
      if(docList.length > 0) {
        for (let i = 0;i< docList.length; i++) {
          let oneDoc = docList[i];
          params[propName].push({
            uid: oneDoc.uid,
            name: oneDoc.name,
            url: oneDoc.url.replace(this.viewUrl, '')
          });
        }
      }
    },
    onSaveDraft(){
      let isDraft = true;
      this.saveAs(isDraft);
    },
    onSubmit(auditorId) {
      let isDraft = false;
      this.saveAs(isDraft,auditorId);
    },
    saveAs(isDraft, auditorId){
      if(auditorId===undefined || auditorId === null) {
        auditorId = "";
      }
      let params = {
        ...this.sectionThree,
        projectId: this.projectId,
        internalState: isDraft ? "未提交" : "已提交",
        mode: this.mode,
        loadReportDocList: [],
        initialDesignDocList: [],
        gridIngestionDocList: [],
        powerConnectionDocList: [],
        powerConnectionReplyDocList: [],
        techFeasibleDocList: [],
        otherAttachmentDocList: [],
        registrationDocList: [],
        landUsageOpinionDocList: [],
        envReviewDocList: [],
        socialStableDocList: [],
        auditorId: auditorId
      };
      this.prepareDocList(this.loadReport.docList, params, "loadReportDocList");
      this.prepareDocList(this.initialDesign.docList, params, "initialDesignDocList");
      this.prepareDocList(this.gridIngestion.docList, params, "gridIngestionDocList");
      this.prepareDocList(this.powerConnection.docList, params, "powerConnectionDocList");
      this.prepareDocList(this.powerConnectionReply.docList, params, "powerConnectionReplyDocList");
      this.prepareDocList(this.techFeasible.docList, params, "techFeasibleDocList");
      this.prepareDocList(this.otherAttachment.docList, params, "otherAttachmentDocList");
      this.prepareDocList(this.registration.docList, params, "registrationDocList");
      this.prepareDocList(this.landUsageOpinion.docList, params, "landUsageOpinionDocList");
      this.prepareDocList(this.envReview.docList, params, "envReviewDocList");
      this.prepareDocList(this.socialStable.docList, params, "socialStableDocList");

      console.log("保存参数", params);
      saveSectionThree(params).then(resp => {
        if (resp.data.code === "SUCCESS") {
          let projectId = resp.data.data;
          console.log('emit section 3 saved event');
          this.$emit('sectionSaved', projectId);
        } else {
          this.$message.error("操作失败: " + resp.data.errorMsg);
          this.$emit('saveSectionFailed');
        }
      });
    },
    onSocialStableUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.socialStable.docList = fileList;
    },
    onTechFeasibleUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.techFeasible.docList = fileList;
    },
    onOtherAttachmentUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.otherAttachment.docList = fileList;
    },
    onRegistrationDocUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.registration.docList = fileList;
    },
    onEnvReviewDocChange(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.envReview.docList = fileList;
    },
    onLoadReportUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.loadReport.docList = fileList;
    },
    onInitialDesignUpload(info){
      let fileList = this.changeToAbsImgPath(info);
      this.initialDesign.docList = fileList;
    },
    onGridIngestionUpload(info){
      let fileList = this.changeToAbsImgPath(info);
      this.gridIngestion.docList = fileList;
    },
    onPowerConnectionUpload(info){
      let fileList = this.changeToAbsImgPath(info);
      this.powerConnection.docList = fileList;
    },
    onPowerConnectionReplyUpload(info){
      let fileList = this.changeToAbsImgPath(info);
      this.powerConnectionReply.docList = fileList;
    },
    showSectionTwo(){
      this.$router.push({
        path: "/adm/section-two/" + this.projectId + "/" + this.mode
      });
    },
    onPreviewFile(doc){
      this.$refs.docPreview.previewFile(doc);
    }

  }
}
</script>
<style scoped>
.container {
  width: 100%;
  background-color: white;
  box-sizing: border-box;
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
}
.long-input {
  max-width: 80%;
}
.medium-input {
  max-width: 60%;
}
.remark-input {
  max-width: 30%;
}
.field-container {
  padding-bottom: 12px;
}
.field-label-container {
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.85)
}
.field-label {
  margin-left: 4px;
}
.required-mark {
  color: red;
  margin-right: 2px;
}
.action-container {
  padding-top: 20px;
}
.draft-btn {
  margin-right: 30px;
}
.doc-uploader {
  margin-top: 12px;
}
.year-input {
  width: 100px;
}
.field-input-container {
  padding-top:10px;
  padding-bottom: 10px;
}
</style>
